var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._g({class:_vm.$style.root},_vm.$listeners),[_vm._t("default",null,{"imgClass":_vm.$style.img}),_vm._t("character",[_c('Character',{class:_vm.$style.character})],{"characterClass":_vm.$style.character})],2)}
var staticRenderFns = []

export { render, staticRenderFns }